import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg'

const Splash = ({ width = 156, height = 110 }) => (
  <Svg width={width} height={height} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path
      d="M100 0c55.247 0 100 44.753 100 100s-44.753 100-100 100S0 155.247 0 100 44.753 0 100 0z"
      fill="url(#paint0_linear_1413_113281)"
    />
    <Path
      d="M70.185 59.506h-3.21c-6.05 0-9.382 3.58-9.382 10.679v34.444c0 8.889-2.902 11.976-9.63 11.976-5.309 0-9.63-2.408-13.025-6.79-.308-.432-7.284 3.024-7.284 11.481 0 9.198 8.272 14.815 23.642 14.815 18.704 0 28.519-9.753 28.519-31.173V70.185c0-7.099-3.334-10.679-9.63-10.679zm77.963 16.667c-18.889 0-31.42 11.975-31.42 29.815 0 17.839 12.099 30.061 31.111 30.061 19.013 0 31.297-11.728 31.297-29.938s-12.284-29.938-30.926-29.938h-.062zM147.901 120c-7.345 0-12.407-5.371-12.407-13.148 0-7.778 5.185-13.025 12.407-13.025s12.408 5.432 12.408 13.148c0 7.716-5.309 13.025-12.408 13.025zm-47.469-41.05h-2.284c-5.679 0-9.938 2.655-9.938 10.741v36.914c0 8.21 4.197 10.741 10.185 10.741h2.284c5.679 0 9.691-2.778 9.691-10.741V89.691c0-8.271-3.95-10.74-9.938-10.74zm-.926-28.024c-7.16 0-11.605 4.012-11.605 10.37s4.63 10.432 11.975 10.432c7.346 0 11.605-4.012 11.605-10.432 0-6.42-4.629-10.37-11.975-10.37z"
      fill="#fff"
    />
    <Defs>
      <LinearGradient id="paint0_linear_1413_113281" x1={0} y1={0} x2={200} y2={200} gradientUnits="userSpaceOnUse">
        <Stop offset={0.15} stopColor="#F2BE75" />
        <Stop offset={0.85} stopColor="#E0A039" />
      </LinearGradient>
    </Defs>
  </Svg>
)
export default Splash
